import { createAsyncThunk } from '@reduxjs/toolkit'
import { ThunkConfig } from '../../../types/store'
import { alertErrorMessage } from '../../../utils/Errors'
import { getUrlWithVersion } from '../../../api/api'

export const cancelAction = createAsyncThunk<
    void,
    { actionId: string },
    ThunkConfig<string>
>('actionsSlice/cancelAction', async (arg, thunkAPI) => {
    const {
        extra: { api },
        rejectWithValue,
    } = thunkAPI

    const { actionId } = arg

    try {
        await api.put(getUrlWithVersion(`/actions/${actionId}/status`), {
            action_status: 'canceled',
        })
    } catch (e) {
        alertErrorMessage(e)
        return rejectWithValue('Failed to cancel action')
    }
})
